import React from 'react'
import './AboutUs.css'
import About from '../../assets/About.png'

import Mission from '../../assets/Mission.png'

function AboutUsCard() {
  return (
    <div className='about_container'>
      <div className="home_max_width">

        {/* Top content - with padding */}
        <div className="about_body">
          <div className="about_head">
            <h1>What We Do</h1>
            <p>About CreateTribute</p>
          </div>

          <div className="flexedCard">
            <div className="flexText">
              <h2>A place to remember, honour, and preserve the lives of those we love.</h2>

              <p>CreateTribute is a digital memorial platform that helps families and friends come together to celebrate a life, share memories, and keep legacies alive long after the moment has passed.</p>
              <p>In a world where people are often separated by distance, we give you a space to connect, reflect, and remember together.</p>
              <p>CreateTribute is a product of Codefixbug limited, a software company located in Nigeria, its goal is to provide simplified solutions that solve problems in Nigeria, Africa, and around the world. CreateTribute is an indigenous platform, created for the greater good of preserving the legacies of people around the world.</p>
              <p>Amy Winehouse in her Back To Black song said "We only said goodbye with words", we got inspired by this to create the platform where people can come together to say goodbye to their loved ones in words, written and shared, which would bring smiles or tears to those who read the tributes and stories.</p>
            </div>
            <div className="flexImage">
              <img src={About} alt="Tribute to a love one - Createtribute" />
            </div>
          </div>
        </div>

        {/* ── OUR STORY — full width, outside about_body ── */}
        <div className="our_story_section">
          <div className="our_story_left">
            <h2 className="our_story_headline">
              Our Story
            </h2>
          </div>
          <div className="our_story_right">
            <p className="our_story_body">
              CreateTribute began with a moment of loss. A family grieving someone they loved wanted a way to honour that life beyond a single day and create a space where friends and relatives could share memories, send messages, and feel connected from anywhere. When it became clear there was no simple way to do this, we built one.
            </p>
            <p className="our_story_body">
              What started as a solution for one family revealed a deeper need. Many people want to preserve memories and celebrate the lives of their loved ones, but lack the tools to do it in a meaningful and lasting way. Today, CreateTribute helps families and communities come together to remember, reflect, and keep those memories alive, because <strong>every life deserves to be remembered and every memory deserves a place to live.</strong>
            </p>
          </div>
        </div>

        {/* ── WHAT WE BELIEVE — full width, outside about_body ── */}
        <div className="beliefs_section">
          <span className="beliefs_label">What We Believe</span>
          <div className="beliefs_grid">
            <div className="belief_card">
              <div className="belief_num">01</div>
              <h3 className="belief_title">Why We Exist</h3>
              <div className="belief_text">
                <p>Losing someone you love is never easy. While funerals bring people together for a moment, memories deserve more than a single day.</p>
                <br/>
                <p>We created CreateTribute to give those memories a permanent home.</p>
                <br/>
                <p>
                  A place where<br />
                  stories are never lost<br />
                  photos live on<br />
                  and love continues to be shared
                </p>
              </div>
            </div>
            <div className="belief_card">
              <div className="belief_num">02</div>
              <h3 className="belief_title">What You Can Do on CreateTribute</h3>
              <div className="belief_text">
                <p>With CreateTribute, you can</p>
                <ul style={{ paddingLeft: '20px', marginTop: '10px', marginBottom: '10px' }}>
                  <li>Create a beautiful memorial page in minutes</li>
                  <li>Share stories, messages, and tributes</li>
                  <li>Upload photos and preserve life moments</li>
                  <li>Invite family and friends to contribute</li>
                  <li>Keep everything safe, private, or public based on your preference</li>
                </ul>
                <p>Every tribute becomes a living memory that grows over time.</p>
              </div>
            </div>
            <div className="belief_card">
              <div className="belief_num">03</div>
              <h3 className="belief_title">Built for Real Life, Real Culture</h3>
              <div className="belief_text">
                <p>In Nigeria and across the world, remembrance is deeply rooted in culture, family, and community.</p>
                <br/>
                <p>CreateTribute does not replace tradition. It extends it.</p>
                <br/>
                <p>Whether loved ones are nearby or far away, everyone can participate, share, and honour a life in a meaningful way.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Mission - back inside padded body */}
        <div className="about_body_bottom">
          <div className="flexedCardReverse">
            <div className="flexImage">
              <h2 className='showMobile'>Our Mission</h2>
              <img src={Mission} alt="Tribute to a love one - Createtribute" />
            </div>
            <div className="flexText">
              <h2 className='showDesktop'>Our Mission</h2>
              <p>Our mission is to help families and friends honour life, share memories, and preserve the legacies of their loved ones through a simple and meaningful online space.</p>
              <p>We are committed to providing a place where tributes, stories, and photos can be safely shared, bringing people together even in times of loss. It is a privilege to support you and your family during moments that matter most, and to help ensure that every memory is preserved with care and respect.</p>
            </div>
          </div>
        </div>

      </div>

      {/* ── OUR PROMISE — full width, dark background ── */}
      <div className="promise_section">
        <h2 className="promise_headline">Our Promise To You</h2>
        <div className="promise_text_container">
          <p className="promise_body">
            Each online memorial comes with features that enable family, friends, and love ones to digitally celebrate the life of their loved ones, by sharing the memories, tributes, and stories of those that have passed away. Creators of each memorial have full control over the memorials they create, some of the features include; About the departed, the life history, birth and death dates, the image, other gallery images of the deceased with members of the family, and a tribute song.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AboutUsCard